<!-- 添加/修改指导模板，bluesky:2023-10-05 -->
<template>
  <div class="add-or-edit-section">
    <el-form :label-position="'right'" label-width="100px" :model="formData" :rules="rules" ref="form">
        <el-form-item label="标题:" prop="title">
            <el-input v-model="formData.title" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="类型:" prop="regulateType">
          <el-select @change="changeType" v-model="formData.regulateType" placeholder="请选择">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <!-- 年度监管类型才显示监管阶段 -->
        <el-form-item v-if="formData.regulateType == 0" label="监管阶段:" prop="stageOrder">
          <el-select v-model="formData.stageOrder" placeholder="请选择">
              <el-option
                v-for="item in stageList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="主要指导内容:" prop="mainDesc">
            <el-input type="textarea" v-model="formData.mainDesc" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item>
            <el-checkbox v-model="hasTreeDescBool">是否显示植被指导内容</el-checkbox>
        </el-form-item>

        <el-form-item>
            <el-checkbox v-model="hasWeatherDescBool">是否显示天气提示</el-checkbox>
        </el-form-item>

        <div>
          <div slot="footer" class="dialog-footer-in-form">
            <el-button plain @click="close">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
          </div>
        </div>

    </el-form>
  </div>
</template>

<script>
export default {
    props:{
        idInput:null,
    },
    created(){
    	this.formData.id = this.idInput;
    	//如果idInput不为空，表示修改
    	if(this.idInput && this.idInput != null){
    		this.getItem();
    	}

      // 获取所有监管类型列表
      this.getRegulateTypeList();

      // 获取所有监管阶段列表
      this.getStageOrderList();
    },
    watch:{
      hasTreeDescBool(newVal){
        console.log("hasTreeDescBool",newVal);
        this.formData.hasTreeDesc = newVal ? 1 : 0;
      },
      hasWeatherDescBool(newVal){
        console.log("hasWeatherDescBool",newVal);
        this.formData.hasWeatherDesc = newVal ? 1 : 0;
      },
    },

    data(){
        return {
            formData: {
              id:null,// 植被ID
              title:null,// 指导标题
              regulateType:null,// 监管类型（0=年度，1=分期，2=巡查，3=关闭，4=其他）
              stageOrder:null,// 监管阶段（0=初始阶段，1=第1阶段，2=第2阶段，3=第3阶段，4=第4阶段，5=整改阶段）
              mainDesc:null,// 主要指导内容
              hasTreeDesc:0,// 是否显示植被指导内容
              hasWeatherDesc:0,// 是否显示天气提示（如：未来3天有降雨）
            },
            rules:{
                title:{required:true,message:'指导标题不能为空',trigger:'blur'},
                regulateType:{required:true,message:'监管类型不能为空',trigger:'blur'},
                stageOrder:{required:true,message:'监管阶段不能为空',trigger:'blur'},
                mainDesc:{required:true,message:'主要指导内容不能为空',trigger:'blur'},
            },

            hasTreeDescBool:false,
            hasWeatherDescBool:false,


            // 监管类型列表
            typeList:[],

            // 监管阶段列表
            stageList:[],
        }
    },
    methods:{
      // 改变类型
      changeType(){
        if(this.formData.regulateType == 1){
          this.rules.stageOrder.required = true;
        }
        else{
          this.rules.stageOrder.required = false;
        }

      },
      // 改变月份
      changeMonthList(){

      },
      // 获取所有监管阶段列表
      getStageOrderList(){
        this.$apis.get('/admin/project/getStageOrderList', {
          }).then(res => {
            if(res.data.code == 200){
              this.stageList = res.data.data;
            }
            else{
              this.$message({
                type: 'error',
                message: `${res.data.data}`
              });
            }
          });
      },
      // 获取所有监管类型列表
      getRegulateTypeList(){
        this.$apis.get('/admin/project/getRegulateTypeList', {
        }).then(res => {
          if(res.data.code == 200){
            this.typeList = res.data.data;
          }
          else{
            this.$message({
              type: 'error',
              message: `${res.data.data}`
            });
          }
        });
      },
      getItem(){
        this.$apis.get('/admin/tipsTpl/get', {
          id:this.formData.id
        }).then(res => {
          if(res.data.code == 200){
            this.formData = res.data.data;
            this.hasTreeDescBool = res.data.data.hasTreeDesc == 1;
            this.hasWeatherDescBool = res.data.data.hasWeatherDesc == 1;
          }
          else{
            this.$message({
              type: 'error',
              message: `${res.data.data}`
            });
          }
        });
      },

      submit(){
        //验证rules
        this.$refs.form.validate(async (valid)=>{
          console.log(valid)
          if(valid){
            let url = this.formData.id && this.formData.id != "" ? "/admin/tipsTpl/update" : "/admin/tipsTpl/add";
            this.$apis.post(url, this.formData).then(res => {
              if(res.data.code == 200){
                this.formData = res.data.data;
                this.$emit("success");
                this.$message({
                  type: 'success',
                  message: `操作成功！`
                });
              }
              else{
                this.$message({
                  type: 'error',
                  message: `${res.data.data}`
                });
              }
            });
          }
        });
      },
      // 关闭
      close(){
        this.$emit("close");
      },

    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/components/addOrEditTipsTpl.vue